module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-module"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "brandList clearfix",
    attrs: {
      "id": "brandListDiv"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "brandList-item"
    }, [_c('ul', _vm._l((item.storePinPaiSlideDTOList), function(item2, index) {
      return _c('li', {
        directives: [{
          name: "mouseenter",
          rawName: "v-mouseenter"
        }],
        key: index,
        class: {
          active: index == 0
        },
        style: ({
          backgroundImage: ("url(" + (item2.img) + ")")
        })
      }, [_c('router-link', {
        attrs: {
          "to": item2.slidePinPaiUrl
        }
      })], 1)
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "brandList-info"
    }, [_c('div', {
      staticClass: "store-name"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/shop',
          query: {
            tab: 1,
            store_id: item.storeId
          }
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.storeName) + "\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
      staticClass: "store-slogon"
    }, [_vm._v("\n                    \t" + _vm._s(!!item.shopsigns ? item.shopsigns : "品质生活从这里开始") + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "store-rate"
    }, [_vm._v("好评率：" + _vm._s(item.praiseRate * 100) + "%")])])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "module-title"
  }, [_c('span', [_vm._v("企业品牌")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1231b22b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/enterprise-brand-store/store-list.vue
// module id = 1532
// module chunks = 1